export default __webpack_public_path__ + "static/comment-debarrasser-partenaire-affaires-scaled-8e025ac8da22df564c066d0876840e29.jpg";